var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"avatar-uploader",style:({
    height: '100%',
    widht: '100%',
  }),attrs:{"action":"#","show-file-list":false,"auto-upload":false,"on-change":_vm.handleChange,"accept":"image/*","multiple":_vm.multiple}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }